import React from 'react';
import { ImageFile } from '~/data/types/images';

const whatsappIcon2Icon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_865_84090)">
        <path
          d="M2.68171 17.0579L2.76431 16.8117L2.61143 16.6017C1.46588 15.0285 0.792187 13.0915 0.792187 11C0.792187 5.72828 5.07883 1.44062 10.349 1.44062H10.3541C15.6243 1.44062 19.9109 5.72949 19.9109 11C19.9109 16.2705 15.6243 20.5594 10.3541 20.5594C8.40925 20.5594 6.60742 19.9813 5.0963 18.9802L4.89512 18.847L4.66525 18.9204L1.74358 19.8544L2.68171 17.0579Z"
          stroke="#262626"
          strokeWidth="1.00625"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.83423 10.722C11.7356 12.6229 12.1669 10.4238 13.3776 11.6336C14.5447 12.8004 15.2155 13.0342 13.7368 14.5125C13.5515 14.6613 12.3747 16.4522 8.23883 12.3175C4.10247 8.18229 5.8923 7.00423 6.0412 6.81906C7.52351 5.33665 7.75326 6.01135 8.92038 7.17815C10.131 8.38843 7.93285 8.82119 9.83423 10.722Z"
          stroke="#262626"
          strokeWidth="1.1204"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_865_84090">
          <rect
            width="20.125"
            height="20.125"
            fill="white"
            transform="translate(0.289062 0.9375)"
          />
        </clipPath>
      </defs>
    </Component>
  );
};

export default whatsappIcon2Icon;
